import { useEffect } from 'react';

export const Admin = () => {
  useEffect(() => {
    window.location.href = 'https://strapi-m8t8.onrender.com/admin/auth/login';
  }, []);

  return null;
};
